import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";

type NotificationState = {
  unreadCount: number;
};

const initialState: NotificationState = {
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    clearNotificationUnread: (state) => {
      state.unreadCount = 0;
    },
  },
});

export const { setNotificationUnreadCount, clearNotificationUnread } =
  notificationSlice.actions;

export default notificationSlice.reducer;

export const selectNotificationUnreadCount = (state: RootState) =>
  state?.notification?.unreadCount;
